// @ts-ignore
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Approval.css";
import axios from "axios";
import {
  HEADERS,
  GetDepartmentwithHead,
  getOrgId,
  LeaveRequestApprove,
} from "../api";
import Swal from "sweetalert2";

function RequestForm() {
  const [departmentdata, setDepartmentdata] = useState([]);
  const [leaveRemarks, setLeaveRemarks] = useState("");
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  const requested_by_namesss = urlParams.get("requested_by_name") || "";
  const requested_by_namefff = urlParams.get("leave_request_id") || "";
  const department_namefff = urlParams.get("department_name") || "";
  const begin_date = urlParams.get("begin_date") || "";
  const end_date = urlParams.get("end_date") || "";
  const leave_type_id = urlParams.get("leave_type_name") || "";
  const description_leave = urlParams.get("leave_description") || "";
  const days_off = urlParams.get("days_off") || "";
  const hoursOff = parseInt(urlParams.get("hours_off")) || 0;
  const testPopup = () => {
    Swal.fire("Test Popup", "If you see this, SweetAlert is working.", "info");
  };

  useEffect(() => {
    const fetchData = async () => {
      const OrgID = getOrgId();
      try {
        const response = await axios.post(
          GetDepartmentwithHead,
          { org_id: OrgID },
          { headers: HEADERS }
        );
        if (response.data.response_code === "0000") {
          setDepartmentdata(response.data.data);
        } else {
          console.error("Error fetching departments");
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };
    fetchData();
  }, []);

  const handleLeaveRemarksChange = (e) => {
    setLeaveRemarks(e.target.value);
  };

  const ApprovalBtn = async () => {
    console.log("Approval button clicked");

    const requestBody = {
      leave_request_id: requested_by_namefff,
      leave_status: 2,
      remarks: leaveRemarks,
      department: urlParams.get("department") || "",
    };
    const result = await Swal.fire({
      title: "Approval Confirmation",
      text: "Are you sure you want to approve this request?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Approve",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      customClass: {
        confirmButton: "swal-custom-confirm-btn",
        cancelButton: "swal-custom-cancel-btn",
      },
    });

    console.log("User confirmed:", result.isConfirmed);
    if (result.isConfirmed) {
      try {
        const response = await axios.post(LeaveRequestApprove, requestBody, {
          headers: HEADERS,
        });
        if (String(response.data.response_code).trim() === "0000") {
          await Swal.fire({
            title: "Success",
            text: "Request has been approved",
            icon: "success",
            customClass: {
              confirmButton: "swal-custom-confirm-btn",
            },
          }).then(() => navigate("/approval"));
        } else {
          await Swal.fire({
            title: "Failed",
            text: response.data.response_description || "Approval failed.",
            icon: "error",
            customClass: {
              confirmButton: "swal-custom-confirm-btn",
            },
          });
        }
      } catch (error) {
        await Swal.fire({
          title: "Failed",
          text: error.data.response_description || "Approval failed.",
          icon: "error",
          customClass: {
            confirmButton: "swal-custom-confirm-btn",
          },
        });
      }
    } else {
    }
  };

  const RejectBtn = async () => {
    if (!leaveRemarks.trim()) {
      return await Swal.fire({
        text: "Please enter your rejection remark.",
        icon: "warning",
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
      });
    }

    const requestBody = {
      leave_request_id: requested_by_namefff,
      leave_status: 3,
      remarks: leaveRemarks,
      department: urlParams.get("department") || "",
    };

    const result = await Swal.fire({
      title: "Reject Confirmation",
      text: "Are you sure you want to reject this request?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Reject",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      customClass: {
        confirmButton: "swal-custom-confirm-btn",
        cancelButton: "swal-custom-cancel-btn",
      },
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.post(LeaveRequestApprove, requestBody, {
          headers: HEADERS,
        });
        if (response.data.response_code === "0000") {
          await Swal.fire({
            title: "Success",
            text: "Request has been rejected",
            icon: "success",
            customClass: {
              confirmButton: "swal-custom-confirm-btn",
            },
          }).then(() => navigate("/approval"));
        } else {
          await Swal.fire({
            title: "Failed",
            text: response.data.response_description || "Rejection failed.",
            icon: "error",
            customClass: {
              confirmButton: "swal-custom-confirm-btn",
            },
          });
        }
      } catch (error) {
        console.error(error);
        await Swal.fire({
          title: "Failed",
          text: error.data.response_description || "Approval failed.",
          icon: "error",
          customClass: {
            confirmButton: "swal-custom-confirm-btn",
          },
        });
      }
    }
  };

  const ForwardBtn = () => {
    if (!leaveRemarks.trim()) {
      return Swal.fire({
        text: "Please enter remarks before forwarding.",
        icon: "warning",
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
      });
    }
    Swal.fire({
      html: `
      <h6 class="leave-forward text-center">Leave Forward Details</h6>
        <h5 class="forward mt-4">Forward to Department</h5>
        <select id="forwardDept" class=" form-select">
          <option value="">Select Department</option>
          ${departmentdata
            .map(
              (dept) =>
                `<option value="${dept.dept_id}">${dept.dept_name}</option>`
            )
            .join("")}
        </select>
      `,
      showCancelButton: true,
      confirmButtonText: "Forward",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      confirmButtonColor: "#2D7D9F",

      preConfirm: () => {
        const selectedValue = document.getElementById("forwardDept").value;
        if (!selectedValue) {
          Swal.showValidationMessage("Please select a department.");
        }
        return selectedValue;
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        const requestBody = {
          leave_request_id: requested_by_namefff,
          leave_status: 4,
          remarks: leaveRemarks,
          department: result.value,
        };

        try {
          const response = await axios.post(LeaveRequestApprove, requestBody, {
            headers: HEADERS,
          });
          if (response.data.response_code === "0000") {
            Swal.fire(
              "Forwarded!",
              "Request has been forwarded.",
              "success"
            ).then(() => navigate("/approval"));
          } else {
            Swal.fire("Error", "Failed to forward. Try again later.", "error");
          }
        } catch (error) {
          console.error(error);
          Swal.fire("Error", "An error occurred. Try again later.", "error");
        }
      }
    });
  };

  return (
    <div className="p-2">
      <span className="breadcrumb d-flex gap-2">
        <Link className="previou-link text-decoration-none" to="/Approval">
          Approval
        </Link>
        <span>/</span>
        <span className="current-link text-decoration-none">Request Form</span>
      </span>

      <div className="text-center">
        <h5 className="title pb-3">Request Form</h5>
      </div>

      <div className="request-details">
        <div className="border detail-header">
          <div className="row p-4">
            <div className="d-flex justify-content-center pb-4">
              <span className="text-center bg-white information-de">
                <strong>Employee Information</strong>
              </span>
            </div>
            <div className="col-md-6 headerss">
              <h2 className="text-white">
                <strong>{requested_by_namesss}</strong>
              </h2>
              <span className="text-white">
                Department: {department_namefff}
              </span>
            </div>
            <div className="col-md-6 headerss">
              <div className="d-flex flex-row">
                <span className="width-min text-white">Start Date</span>
                <span className="text-white">: {begin_date}</span>
              </div>
              <div className="d-flex flex-row">
                <span className="width-min text-white">End Date</span>
                <span className="text-white">: {end_date}</span>
              </div>
            </div>

            <div className="mt-3 bg-white rounded p-3">
              <div className="col-md-6 headerss">
                <div className="d-flex flex-row">
                  <h5 style={{ width: "130px", fontSize: "16px" }}>
                    Leave Type
                  </h5>
                  <span style={{ fontSize: "16px" }}>: {leave_type_id}</span>
                </div>
                <div className="d-flex flex-row">
                  <h5 style={{ width: "130px", fontSize: "16px" }}>
                    Hours Off
                  </h5>
                  <span style={{ fontSize: "16px" }}>: {hoursOff} hours</span>
                </div>
                <div className="d-flex flex-row">
                  <h5
                    style={{
                      width: "130px",
                      fontWeight: "medium",
                      fontSize: "16px",
                    }}
                  >
                    Days Off
                  </h5>
                  <span>: {days_off}</span>
                </div>
              </div>
              <div>
                <div className="d-flex flex-row">
                  <h5 style={{ width: "130px", fontSize: "16px" }}>Reason</h5>
                </div>
                <textarea
                  className="form-control"
                  value={description_leave}
                  readOnly
                  rows={4}
                />
              </div>

              <div className="mt-3">
                <h5 style={{ width: "130px", fontSize: "16px" }}>Remarks</h5>
                <textarea
                  className="form-control custom-placeholder"
                  style={{ height: "100px" }}
                  placeholder="Type your remark here"
                  value={leaveRemarks}
                  onChange={handleLeaveRemarksChange}
                />
              </div>
              <div className="mt-4 d-flex gap-2 justify-content-end">
                <button className="button add-button" onClick={RejectBtn}>
                  Reject
                </button>
                <button className="button add-button" onClick={ApprovalBtn}>
                  Approve
                </button>
                <button className="button add-button" onClick={ForwardBtn}>
                  Forward
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RequestForm;
